import { render } from "./VTreatmentTime.vue?vue&type=template&id=7547baca"
import script from "./VTreatmentTime.vue?vue&type=script&lang=js"
export * from "./VTreatmentTime.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/offline-booking/VTreatmentTime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7547baca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7547baca', __exports__)) {
    api.reload('7547baca', __exports__)
  }
  
  module.hot.accept("./VTreatmentTime.vue?vue&type=template&id=7547baca", () => {
    api.rerender('7547baca', render)
  })

}


export default __exports__